import { Stack, Typography } from "@mui/material";
import { FC } from "react";

interface CurrentCoordinateColumnProps {
  coordinate: Coordinate | undefined;
}

const CurrentCoordinateColumn: FC<CurrentCoordinateColumnProps> = ({ coordinate }) => {
  if (coordinate) {
    return (
      <Stack>
        <Typography>lat. : {coordinate.latitude.toFixed(6).replace(".", ",")}</Typography>
        <Typography>lng. : {coordinate.longitude.toFixed(6).replace(".", ",")}</Typography>
      </Stack>
    );
  }

  return <Typography>-</Typography>;
};

export default CurrentCoordinateColumn;
